import FormViewForm from './FormViewForm';
import UserRolePermissionsList from '@src/components/UserRolePermissionsList/UserRolePermissionsList';
import {UserRolesFormModel, UserRolesFormPreparedPermission} from '@src/@types/components/UserRolesForm';
import Cache from '@src/classes/Cacheable/Cache';

const customFields = {
    permissions: {
        component: UserRolePermissionsList,
    }
};

export default class UserRolesForm<Model extends UserRolesFormModel = UserRolesFormModel> extends FormViewForm<Model> {
    cache = new Cache();

    protected get customFields() {
        return customFields;
    }

    protected get customInitialValues(): Record<string, any> {
        const model = this.props.model;
        const modelKey = `${model?.id ?? 'null'}-${model?.updated_at ?? '0'}`;

        return this.cache.remember<Record<string, any>>(`${modelKey}--custom-init-values`, () => {
            const hasParent = model?.parent_id != null;
            const permissionsMap = model?.all_existing_permissions_map ?? {};

            const result: UserRolesFormPreparedPermission[] = [];
            const setUppedPermissions = model?.permissions ?? {};

            for (const existingPermissions of Object.values(permissionsMap)) {
                for (const name in existingPermissions) {
                    let value: UserRolesFormPreparedPermission['value'] = '-';
                    if (name in setUppedPermissions) {
                        value = setUppedPermissions[name] ? '1' : '0';
                    } else {
                        value = hasParent ? '-' : '0';
                    }

                    result.push({name, value});
                }
            }

            return {permissions: result};
        }, cachedResult => {
            return !cachedResult || !cachedResult.permissions.length;
        });
    }

    protected mutateModelFieldInitialValue(fieldName: string, modelValue: any): any {
        if (fieldName !== 'permissions' || modelValue == null) {
            return super.mutateModelFieldInitialValue(fieldName, modelValue);
        }

        return this.customInitialValues.permissions;
    }

    protected async onSubmit(data: Record<string, any>): Promise<any> {
        if ('permissions' in data && Array.isArray(data.permissions)) {
            data.permissions = data.permissions.reduce<Record<string, boolean | null>>((res, item: UserRolesFormPreparedPermission) => {
                if (item.value !== '-') {
                    res[item.name] = Boolean(+item.value);
                }

                return res;
            }, {});
        }

        return super.onSubmit(data);
    }
}
